import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as appActions from '../dux/actions/appActions'
import * as searchActions from '../dux/actions/search'
import * as userActions from '../dux/actions/user'
import { isAdmin, isContentAdmin } from '../dux/modules/utils'
import { canViewAnalytics } from '../dux/modules/appAccess'
import { openAppWithHandoff } from '../dux/modules/ssoHandoff'
import BamHeader from './BamHeader'

class BamHeaderContainer extends React.Component {
  handleClick = (e) => {
    // "App" leaves the DAM entirely, so it neither routes nor becomes the
    // selected menu item -- the user comes back to whatever they were on.
    if (e.key === 'app') {
      openAppWithHandoff(this.props.config)
      return
    }
    this.props.appActions.setMenuItem(e.key)
  }

  onChangeSearch = (e) => {
    this.props.searchActions.setQuery(e.target.value)
  }

  onSubmitSearch = () => {
    // Block search if other action is pending (like existing search)
    if (!this.props.loading) {
      // First scrub the search input, remove any escape slashes
      const query = this.props.searchQuery.replace(/\\/gi, ' ')

      this.props.history.push('/library/_search')
      this.props.searchActions.submitSearch(query)
    }
  }

  isDisabled = () => {
    let disabled = false
    if (this.props.menuItem !== 'library') disabled = true

    return disabled
  }

  // Where the header's "Settings" button goes: back to whichever settings
  // page was last open. Both lookups can miss -- a settings route reached by
  // URL rather than by clicking the sidebar sets the active key and item from
  // the path, and a path the menu does not list (/settings/permissions/approval,
  // which arrives as a link in an approval email) leaves nothing to find.
  // Unguarded, that threw inside render and blanked the whole DAM, so fall
  // back to the first item of the active panel, then to the first item there
  // is, and only then to nothing.
  getSettingsLink = () => {
    const { settingsActiveKey, settingsActiveItem, settingsMenu } =
      this.props.settings
    const menu = settingsMenu || []
    const panel = menu.find((key) => key.id === settingsActiveKey) || menu[0]
    const items = (panel && panel.items) || []
    const item =
      items.find((entry) => entry.id === settingsActiveItem) || items[0]
    return (item && item.route) || '/settings'
  }

  render() {
    return (
      <BamHeader
        isAdmin={isAdmin(this.props.user.email, this.props.groups)}
        isContentAdmin={isContentAdmin(
          this.props.user.email,
          this.props.groups,
        )}
        canViewAnalytics={canViewAnalytics(
          this.props.user.email,
          this.props.groups,
        )}
        mask={this.props.config.mask}
        handleClick={this.handleClick}
        onChangeSearch={this.onChangeSearch}
        onSubmitSearch={this.onSubmitSearch}
        selectedKeys={[this.props.menuItem]}
        activeFolder={this.props.activeFolder}
        searchQuery={this.props.searchQuery}
        settingsLink={this.getSettingsLink()}
        isDisabled={this.isDisabled}
        logoWidth={this.props.logoWidth}
        modules={this.props.settings.modules}
      />
    )
  }
}

BamHeaderContainer.propTypes = {
  activeFolder: PropTypes.string,
  config: PropTypes.object,
  user: PropTypes.object,
  loading: PropTypes.bool,
  menuItem: PropTypes.string,
  searchQuery: PropTypes.string,
  groups: PropTypes.object,
  history: PropTypes.object,
  userActions: PropTypes.object,
  appActions: PropTypes.object,
  searchActions: PropTypes.object,
  logoWidth: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    activeFolder: state.folders.activeFolder,
    user: state.user,
    loading: state.appState.asyncPending,
    menuItem: state.appState.menuItem,
    searchQuery: state.search.searchQuery,
    groups: state.permissions.groups,
    settings: state.settings,
    config: state.config.appConfig,
  }
}

const mapDispatchToProps = (dispatch) => ({
  userActions: bindActionCreators(userActions, dispatch),
  appActions: bindActionCreators(appActions, dispatch),
  searchActions: bindActionCreators(searchActions, dispatch),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BamHeaderContainer),
)
